webpackJsonp([1],{

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 125:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(188)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(186)

var Component = __webpack_require__(18)(
  /* script */
  null,
  /* template */
  __webpack_require__(259),
  /* scopeId */
  "data-v-6f02a5f5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('md-spinner', __WEBPACK_IMPORTED_MODULE_4__components_Spinner___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_5__App___default.a);
  }
});

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_mini__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_mini___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_mini__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__ = __webpack_require__(70);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      meRaw: undefined,
      meLoaded: false
    };
  },

  computed: {
    me: function me() {
      return this.meRaw;
    }
  },
  methods: {
    login: function login() {
      return __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["c" /* firebase */].auth().signInWithPopup(new __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["c" /* firebase */].auth.GoogleAuthProvider());
    },
    logout: function logout() {
      return __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["c" /* firebase */].auth().signOut();
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["c" /* firebase */].auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.$bindAsObject('meRaw', __WEBPACK_IMPORTED_MODULE_2__helpers_firebase__["b" /* db */].child('users/' + user.uid));

        var providerData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user.providerData[0], {
          _loggedin: __WEBPACK_IMPORTED_MODULE_1_moment_mini___default()().format()
        });
        _this.$firebaseRefs.meRaw.update(providerData);
        _this.$firebaseRefs.meRaw.once('value').then(function () {
          _this.meLoaded = true;
        });

        _this.$emit('login');
      } else {
        if (_this.$firebaseRefs && _this.$firebaseRefs.meRaw) {
          _this.$unbind('meRaw');
        }
        _this.meLoaded = true;

        _this.$emit('logout');
      }
    });
  }
});

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csv_stringify__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_csv_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_csv_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_FirebaseAuth__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_firebase__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DataGrouper__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DataGrouper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_DataGrouper__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_FirebaseAuth__["a" /* default */]],
  data: function data() {
    return {
      file: undefined,
      list: {
        name: undefined
      },
      listId: undefined,
      dirty: false,
      loading: {
        upload: false,
        download: false,
        save: false,
        duplicate: false
      }
    };
  },

  computed: {
    uploadedFilename: function uploadedFilename() {
      return this.file && this.file.name && this.file.name.replace(/\.\w+$/, '') || undefined;
    }
  },
  methods: {
    handleFileUpload: function handleFileUpload(file) {
      var _this = this;

      this.loading.upload = true;
      this.list.data = undefined;
      this.file = file;

      this.$nextTick(function () {
        var reader = new FileReader();
        reader.onload = function (e) {
          var content = e.target.result;
          switch (file.type) {
            case 'application/json':
              _this.parseJson(JSON.parse(content));
              break;
            case 'text/plain':
            default:
              _this.parseText(content);
              break;
          }
          _this.loading.upload = false;
        };
        reader.readAsText(file);
      });
    },
    fetchText: function fetchText(url) {
      return fetch(url).then(function (res) {
        return res.text();
      });
    },
    fetchJson: function fetchJson(url) {
      return fetch(url).then(function (res) {
        return res.json();
      });
    },
    parseText: function parseText(text) {
      var data = [];
      var lines = text.replace(/^\s+|\s+$/ig, '').split('\n');
      lines.forEach(function (line, i) {
        var value = line.replace(/^\s+|\s+$/ig, '');
        if (value !== '') {
          data.push({
            key: i,
            value: value,
            votes: 1
          });
        }
      });
      this.list.data = data;
      this.list.name = this.uploadedFilename;
    },
    parseJson: function parseJson(json) {
      if (json.data) {
        this.list = json;
        this.list.name = this.list.name || this.uploadedFilename;
      } else {
        this.list.data = json;
        this.list.name = this.uploadedFilename;
      }
    },
    loadText: function loadText(url) {
      return this.fetchText(url).then(this.parseText);
    },
    loadJson: function loadJson(url) {
      return this.fetchJson(url).then(this.parseJson);
    },
    download: function download(contents) {
      var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'grouped';
      var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'txt';

      var a = document.createElement('a');
      var mime = void 0;
      switch (extension) {
        case 'json':
          mime = 'application/json';
          break;
        case 'csv':
          mime = 'text/csv';
          break;
        case 'txt':
        default:
          mime = 'text/plain';
          break;
      }
      a.setAttribute('href', 'data:' + mime + ';charset=utf-8,' + encodeURIComponent(contents));
      a.setAttribute('download', filename + '.' + extension);
      a.click();
    },
    exportJson: function exportJson() {
      var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      this.loading.download = true;
      var jsonBundle = this.$refs.dataGrouper.bundleJson();

      var json = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(jsonBundle, null, 2);

      this.download(json, filename, 'json');
      this.loading.download = false;
    },
    exportCsv: function exportCsv() {
      var _this2 = this;

      var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      this.loading.download = true;
      var jsonBundle = this.$refs.dataGrouper.bundleJson();

      var rows = jsonBundle.data.map(function (datum) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, datum, {
          group: jsonBundle.groupNames[datum.group]
        });
      });
      __WEBPACK_IMPORTED_MODULE_3_csv_stringify___default()(rows, function (err, csv) {
        if (err) throw new Error(err);

        _this2.download(csv, filename, 'csv');
        _this2.loading.download = false;
      });
    },
    loginIfNecessary: function loginIfNecessary() {
      var _this3 = this;

      if (!this.me) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          _this3.$refs.loginConfirm.open();
          _this3.$refs.loginConfirm.$on('close', function (state) {
            if (state === 'ok') return resolve();
            return reject('User cancelled');
          });
        }).then(this.login).then(function () {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
            var unwatch = _this3.$watch('me', function (me) {
              if (me) {
                resolve(_this3.me);
                unwatch();
              }
            });
          });
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    },
    save: function save() {
      var _this4 = this;

      var asDuplicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var doLoading = function doLoading(status) {
        if (asDuplicate) {
          _this4.loading.duplicate = status;
        } else {
          _this4.loading.save = status;
        }
      };
      doLoading(true);

      this.loginIfNecessary().then(function () {
        if (!_this4.me || !_this4.me[__WEBPACK_IMPORTED_MODULE_5__helpers_firebase__["a" /* idKey */]]) throw new Error('You need to be logged in.');

        var bundle = _this4.$refs.dataGrouper.bundleJson();
        var myListsRef = __WEBPACK_IMPORTED_MODULE_5__helpers_firebase__["b" /* db */].child('users:lists/' + _this4.me[__WEBPACK_IMPORTED_MODULE_5__helpers_firebase__["a" /* idKey */]]);

        if (_this4.listId && !asDuplicate) {
          var listRef = myListsRef.child(_this4.listId);
          return listRef.set(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, bundle)).then(function () {
            return listRef;
          });
        }

        return myListsRef.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, bundle));
      }).then(function (ref) {
        _this4.listId = ref.key;
        _this4.$refs.snackbar.open();

        doLoading(false);
        _this4.dirty = false;
      }).catch(function (err) {
        console.error(err);

        doLoading(false);
      });
    }
  },
  created: function created() {
    this.loadJson('/static/grouped.json');
  },

  components: {
    DataGrouper: __WEBPACK_IMPORTED_MODULE_6__components_DataGrouper___default.a
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Droppable__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Droppable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Droppable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Group__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Group__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'data-grouper',
  props: {
    initialList: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      data: [],
      groupNames: {},
      collapseAll: false,
      barMode: false
    };
  },

  computed: {
    numGroups: function numGroups() {
      return this.data.reduce(function (group, datum) {
        return Math.max(group, datum.group || 0);
      }, 0);
    },
    groupNumsSortedByTotal: function groupNumsSortedByTotal() {
      var groupNums = [];
      for (var group = 1; group <= this.numGroups; group += 1) {
        groupNums.push({
          group: group,
          total: this.grouped(group || undefined).reduce(function (votes, datum) {
            return votes + datum.votes;
          }, 0)
        });
      }
      return groupNums.sort(function (a, b) {
        return b.total - a.total || b.group - a.group;
      }).map(function (groupNum) {
        return groupNum.group;
      });
    }
  },
  methods: {
    grouped: function grouped() {
      var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      return this.data.filter(function (d) {
        return (d.group || 0) === (group || 0);
      });
    },
    handleMove: function handleMove(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
          datum = _ref2[0];

      var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (this.data) {
        var index = this.data.findIndex(function (d) {
          return d.key === datum.key;
        });

        if (index >= 0 && this.data[index] && (this.data[index].group || 0) !== (group || 0)) {
          this.$set(this.data[index], 'group', group || null);

          this.$emit('dirty');
        }
      }
    },
    handleGroupNameChange: function handleGroupNameChange(_ref3) {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
          name = _ref4[0],
          group = _ref4[1];

      this.groupNames[group] = name || undefined;

      this.$emit('dirty');
    },
    handleCollapseAll: function handleCollapseAll() {
      if (this.collapseAll) {
        this.EventBus.$emit('group.expandAll');
      } else {
        this.EventBus.$emit('group.collapseAll');
      }
      this.collapseAll = !this.collapseAll;
    },
    bundleJson: function bundleJson() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.initialList, {
        groupNames: this.groupNames,
        data: this.data
      });
    }
  },
  mounted: function mounted() {
    this.data = this.initialList.data || [];
    this.groupNames = this.initialList.groupNames || {};
  },

  components: {
    Droppable: __WEBPACK_IMPORTED_MODULE_2__Droppable___default.a,
    Group: __WEBPACK_IMPORTED_MODULE_3__Group___default.a
  }
});

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Draggable__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Draggable__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datum',
  props: {
    datum: {
      type: Object,
      required: true
    }
  },
  components: {
    Draggable: __WEBPACK_IMPORTED_MODULE_0__Draggable___default.a
  }
});

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'draggable',
  props: {
    dragData: {
      required: false
    }
  },
  data: function data() {
    return {
      dragging: false
    };
  },

  methods: {
    setData: function setData(e) {
      e.dataTransfer.setData('application/json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.dragData || ''));

      return [this.dragData, e];
    },
    getData: function getData(e) {
      var json = e.dataTransfer.getData('application/json') || '';

      return [json && JSON.parse(json), e];
    }
  }
});

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'droppable',
  data: function data() {
    return {
      dragover: false
    };
  },

  methods: {
    checkBubbling: function checkBubbling(e) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'drag-over';

      var el = e.target;
      while (el && !el.classList.contains('droppable')) {
        el = el.parentElement;
      }

      if (el) {
        this.dragover = true;
        this.$emit(type, this.getData(e));
      }
    },
    getData: function getData(e) {
      var json = e.dataTransfer.getData('application/json') || '';

      return [json && JSON.parse(json), e];
    }
  }
});

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_randomcolor__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_randomcolor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_randomcolor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Droppable__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Droppable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Droppable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datum__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Datum__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'group',
  props: {
    groupNum: {
      type: Number
    },
    data: {
      type: Array
    },
    groupName: {
      type: String
    },
    collapsable: {
      type: Boolean,
      default: true
    },
    tooltip: {
      type: String,
      default: function _default() {
        return this.collapsable ? 'Expand/Collapse' : '';
      }
    }
  },
  data: function data() {
    return {
      name: undefined,
      collapsed: false
    };
  },

  computed: {
    sortedData: function sortedData() {
      return this.data.sort(function (a, b) {
        return b.votes - a.votes || b.group - a.group || (a.value || '').localeCompare(b.value || '');
      });
    },
    totalVotes: function totalVotes() {
      return this.data.reduce(function (votes, datum) {
        return votes + datum.votes;
      }, 0);
    }
  },
  methods: {
    getGroupColor: function getGroupColor(groupNum) {
      return groupNum && __WEBPACK_IMPORTED_MODULE_0_randomcolor___default()({
        luminosity: 'light',
        seed: groupNum * groupNum
      });
    },
    handleCollapse: function handleCollapse(event) {
      if (this.collapsable) {
        this.collapsed = !this.collapsed;
      }
      this.$emit('collapse', event);
    },
    handleNameChange: function handleNameChange(e) {
      this.$emit('group-name-change', [this.name, this.groupNum, e]);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.EventBus.$on('group.expandAll', function () {
      if (_this.collapsable) _this.collapsed = false;
    });
    this.EventBus.$on('group.collapseAll', function () {
      if (_this.collapsable) _this.collapsed = true;
    });
  },

  components: {
    Droppable: __WEBPACK_IMPORTED_MODULE_1__Droppable___default.a,
    Datum: __WEBPACK_IMPORTED_MODULE_2__Datum___default.a
  }
});

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./locale": 116,
	"./locale.js": 116
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 235;

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(184)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(185)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(258),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(187)

var Component = __webpack_require__(18)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(260),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 255:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-grouper",
    class: {
      'bar-mode': _vm.barMode
    }
  }, [_c('group', {
    class: {
      collapsed: _vm.collapseAll
    },
    attrs: {
      "data": _vm.grouped(),
      "tooltip": "Expand/Collapse All"
    },
    on: {
      "collapse": function($event) {
        _vm.handleCollapseAll()
      },
      "drag-drop": function($event) {
        _vm.handleMove($event)
      }
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-raised barMode",
    class: {
      'md-accent': _vm.barMode
    },
    attrs: {
      "slot": "header"
    },
    nativeOn: {
      "click": function($event) {
        _vm.barMode = !_vm.barMode
      }
    },
    slot: "header"
  }, [_c('md-icon', [_vm._v("short_text")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Toggle Bar Mode")])], 1)], 1), _vm._v(" "), _c('droppable', {
    staticClass: "groups",
    on: {
      "drag-drop": function($event) {
        _vm.handleMove($event, _vm.numGroups + 1)
      }
    }
  }, [_c('div', _vm._l((_vm.groupNumsSortedByTotal), function(groupNum) {
    return _c('group', {
      key: groupNum,
      attrs: {
        "group-num": groupNum,
        "data": _vm.grouped(groupNum),
        "group-name": _vm.groupNames[groupNum]
      },
      on: {
        "group-name-change": function($event) {
          _vm.handleGroupNameChange($event)
        },
        "drag-drop": function($event) {
          _vm.handleMove($event, groupNum)
        }
      }
    })
  }))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "draggable",
    class: {
      draggable: true, dragging: _vm.dragging
    },
    attrs: {
      "draggable": ""
    },
    on: {
      "dragstart": function($event) {
        _vm.dragging = true;
        _vm.$emit('drag-start', _vm.setData($event))
      },
      "dragend": function($event) {
        _vm.dragging = false;
        _vm.$emit('drag-end', _vm.getData($event))
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "droppable",
    staticClass: "droppable",
    class: {
      dragover: _vm.dragover
    },
    on: {
      "drop": function($event) {
        $event.stopPropagation();
        _vm.dragover = false;
        _vm.$emit('drag-drop', _vm.getData($event))
      },
      "dragover": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.checkBubbling($event)
      },
      "dragenter": function($event) {
        $event.stopPropagation();
        _vm.checkBubbling($event, 'drag-enter')
      },
      "dragleave": function($event) {
        _vm.dragover = false;
        _vm.$emit('drag-leave', _vm.getData($event))
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('draggable', {
    staticClass: "datum",
    attrs: {
      "drag-data": _vm.datum
    }
  }, [_c('header', [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.datum.value))]), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_vm._v(_vm._s(_vm.datum.votes))])])])
},staticRenderFns: []}

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-button', {
    staticClass: "md-icon-button md-spinner"
  }, [_c('md-icon', [_vm._v("more_vert")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.groupNum || (_vm.groupNum && _vm.data.length)) ? _c('droppable', {
    staticClass: "group",
    class: {
      collapsable: _vm.collapsable, collapsed: _vm.collapsed
    },
    style: ({
      width: _vm.collapsable ? (_vm.totalVotes + "%") : ''
    }),
    on: {
      "drag-drop": function($event) {
        _vm.$emit('drag-drop', $event)
      }
    }
  }, [_c('header', {
    style: ({
      backgroundColor: _vm.getGroupColor(_vm.groupNum)
    })
  }, [_c('div', {
    staticClass: "name"
  }, [(!_vm.groupNum) ? _c('div', [_vm._v("Ungrouped")]) : _c('md-input-container', [_c('md-input', {
    attrs: {
      "value": _vm.groupName,
      "placeholder": ("Group " + _vm.groupNum)
    },
    on: {
      "input": function($event) {
        _vm.handleNameChange($event)
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1), _vm._v(" "), _vm._t("header"), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button total",
    attrs: {
      "disabled": !_vm.collapsable
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleCollapse($event)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.totalVotes) + "\n      "), (_vm.tooltip) ? _c('md-tooltip', [_vm._v(_vm._s(_vm.tooltip))]) : _vm._e()], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }]
  }, _vm._l((_vm.sortedData), function(datum) {
    return _c('datum', {
      key: datum.key,
      attrs: {
        "datum": datum
      }
    })
  })), _vm._v(" "), _vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-dense"
  }, [_c('div', [_c('h1', {
    staticClass: "md-title",
    staticStyle: {
      "margin-right": "auto"
    }
  }, [_vm._v("List Grouper")]), _vm._v(" "), (!_vm.loading.upload) ? _c('md-button', {
    staticClass: "md-icon-button file-upload-button"
  }, [_c('md-icon', [_vm._v("file_upload")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "text/plain,application/json"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload($event.target.files[0])
      },
      "drop": function($event) {
        _vm.handleFileUpload($event.dataTransfer.files[0])
      }
    }
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Upload")])], 1) : _c('md-spinner')], 1), _vm._v(" "), _c('div', [_c('md-input-container', {
    attrs: {
      "md-inline": ""
    }
  }, [_c('md-input', {
    attrs: {
      "placeholder": "Untitled list"
    },
    on: {
      "change": function($event) {
        _vm.dirty = true;
      }
    },
    model: {
      value: (_vm.list.name),
      callback: function($$v) {
        _vm.list.name = $$v
      },
      expression: "list.name"
    }
  })], 1), _vm._v(" "), (!_vm.loading.save) ? _c('md-button', {
    staticClass: "md-icon-button",
    class: {
      'md-raised md-accent': _vm.dirty
    },
    nativeOn: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_c('md-icon', [_vm._v("call_merge")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Save")])], 1) : _c('md-spinner'), _vm._v(" "), (!_vm.loading.duplicate) ? _c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function($event) {
        _vm.save(true)
      }
    }
  }, [_c('md-icon', [_vm._v("call_split")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Duplicate")])], 1) : _c('md-spinner'), _vm._v(" "), (!_vm.loading.download) ? _c('md-menu', {
    attrs: {
      "md-size": "3"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-icon', [_vm._v("file_download")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Download")])], 1), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.exportJson(_vm.uploadedFilename)
      }
    }
  }, [_c('md-icon', [_vm._v("file_download")]), _vm._v(" "), _c('span', [_vm._v("JSON")])], 1), _vm._v(" "), _c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.exportCsv(_vm.uploadedFilename)
      }
    }
  }, [_c('md-icon', [_vm._v("file_download")]), _vm._v(" "), _c('span', [_vm._v("CSV")])], 1)], 1)], 1) : _c('md-spinner'), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex-grow": "1"
    }
  }), _vm._v(" "), (_vm.meLoaded) ? _c('div', [(!_vm.me) ? _c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-1px",
      "margin-left": "-5px",
      "margin-right": "5px"
    },
    attrs: {
      "src": "/static/google-logo.svg",
      "alt": "Google",
      "width": "20"
    }
  }), _vm._v(" Login\n        ")]) : _c('div', [_c('md-menu', {
    attrs: {
      "md-size": "3"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-avatar', [_c('img', {
    attrs: {
      "src": _vm.me.photoURL,
      "role": "presentation"
    }
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Account")])], 1)], 1), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('md-icon', [_vm._v("power_settings_new")]), _vm._v(" "), _c('span', [_vm._v("Logout")])], 1)], 1)], 1)], 1)], 1) : _c('md-spinner')], 1)]), _vm._v(" "), (_vm.list.data) ? _c('data-grouper', {
    ref: "dataGrouper",
    attrs: {
      "initial-list": _vm.list
    },
    on: {
      "dirty": function($event) {
        _vm.dirty = true;
      }
    }
  }) : _c('aside', [_c('div', [_vm._v("No data loaded.")])]), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "loginConfirm",
    attrs: {
      "md-content-html": "You need to login first.",
      "md-ok-text": "Login",
      "md-cancel-text": "Cancel"
    }
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom right"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("\n    Saved!\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export config */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return idKey; });
/* unused harmony export firebaseApp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_database__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a; });




var config = {
  apiKey: 'AIzaSyASPkpXZUbiW2d9Zim08qBrPaFFn9LraOI',
  authDomain: 'list-grouper.firebaseapp.com',
  databaseURL: 'https://list-grouper.firebaseio.com',
  projectId: 'list-grouper'
};
var idKey = '.key';


var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(config);
var db = firebaseApp.database().ref('data');

/***/ })

},[130]);


// WEBPACK FOOTER //
// static/js/app.ce79591bfba167450c59.js